<template>
  <div class="recruit-container">
    <h2 class="page-title">客服 Q&A</h2>
    <div class="recruitment-page">
      <div class="sidebar">
        <div class="sidebar-menu">
          <button v-for="category in categories" :key="category.id" @click="selectCategory(category.id)"
            :class="['category-button', { active: selectedCategory === category.id }]">
            {{ category.name }}
          </button>
        </div>
      </div>
      <div class="main-content">
        <div v-if="loading" class="loading-message">資料加載中...</div>
        <div v-else>
          <div v-if="filteredqnas.length === 0" class="no-data-message">目前沒有此類別的職缺。</div>
          <div v-for="qna in filteredqnas" :key="qna.id">
            <div class="qna-card" @click="toggleAnswer(qna.id)">
              <div class="question">
                <h3>{{ qna.Q }}</h3>
                <!-- <h3>AA</h3> -->
                <!-- <button class="view-button" @click="viewDetails(qna.link)">查看</button> -->
                <button class="toggle-icon" @click="toggleAnswer(qna.id)">{{ qna.showAnswer ? '−' : '+' }}</button>
              </div>
              <div v-if="qna.showAnswer">
                <!-- Render answer without v-linkified if qna.id == 10 -->
                <div v-if="qna.id === 10" class="qna-answer">
                  {{ qna.A }}
                </div>
                <div v-else class="qna-answer" v-linkified>
                  {{ qna.A }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <ContactFooter />
  </div>
</template>

<script>
import ContactFooter from '@/components/ContactFooter.vue';

export default {
  name: 'RecruitmentPage',
  components: {
    ContactFooter,
  },
  data() {
    return {
      loading: true, // Loading state
      selectedCategory: 'all',
      categories: [
        { id: 'all', name: '全部' },
        { id: '繳費問題', name: '繳費問題' },
        { id: '責任問題', name: '責任問題' },
        { id: '停車業務', name: '停車業務' },

      ],
      qnas: [], // qna list fetched from PullDAO
    };
  },
  computed: {
    filteredqnas() {
      if (this.selectedCategory === 'all') {
        return this.qnas;
      }

      return this.qnas.filter(qna => qna.category === this.selectedCategory);
    },
  },
  methods: {

    async fetchQAs() {

      try {
        const response = await fetch('/qa.json'); // Fetching from the public directory
        // console.log('response:', response);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const qaList = await response.json(); // Parse JSON data
        // console.log('qaList:', qaList);
        this.qnas = qaList; // Assign the data to your property
        this.loading = false; // Set loading to false
      } catch (error) {
        console.error('Error fetching QA data:', error);
      }
    },
    async fetchQAsX() {

      const qaList = [
        {
          "id": 1,
          "category": "停車業務",
          "Q": "如何辦理月租?",
          "A": "請與本公司客服聯絡(02)2523-5000，確認承租地點位置後專人服務辨理。新月租用戶請詳細閱讀並填寫車位租賃申請書，另需繳付一個月押金。車位租賃申請書暨押金收據請務必妥善保存，以便未來退租時做為押金退費證明。"
        },
        {
          "id": 2,
          "category": "停車業務",
          "Q": "如何辦理退租?",
          "A": "如欲退租，請於到期日前15天聯絡客服或停車場服務同仁，並填寫退租申請書，並附上車位租賃申請書暨押金收據、遙控器或磁卡。押金退回採匯款方式。若於當月15號前辦理退租者，可於當月月底收到匯款；若於15號以後辦理者，則需於次月月底方能收到匯款。"
        },
        {
          "id": 3,
          "category": "繳費問題",
          "Q": "月租客戶如何繳費？",
          "A": "請至停車場領取帳單，至四大超商、銀行ATM或網路銀行轉帳依專屬帳號繳納月租停車費，並繳費收據於每月15號後至現場換取發票。"
        },
        {
          "id": 4,
          "category": "繳費問題",
          "Q": "逾時繳交月租費是否會產生滯納金？",
          "A": "如逾時繳納或帳單遺失請來電客服索取您的專屬帳號 。"
        },
        {
          "id": 5,
          "category": "繳費問題",
          "Q": "停車場內已超過營業時間未取車，隔夜費用如何計算？",
          "A": "依現場公告臨停費率計算之。"
        },
        {
          "id": 6,
          "category": "責任問題",
          "Q": "停車場是否有保管車內財物之責任？",
          "A": "停車場僅提供停放車輛，不負保管責任，若有貴重物品，車主應帶下車，自行妥善保管。"
        },
        {
          "id": 7,
          "category": "繳費問題",
          "Q": "停車場是否有出入場緩衝時間？",
          "A": "入場並無緩衝時間，至自繳機繳費後；出場緩衝時間為10分鐘。"
        }
      ];

      this.qnas = qaList;
      this.loading = false;


    },

    toggleAnswer(id) {
      const question = this.qnas.find(q => q.id === id);
      question.showAnswer = !question.showAnswer;
    },

    selectCategory(categoryId) {
      this.selectedCategory = categoryId;
    },

  },
  async mounted() {
    await this.fetchQAs(); // Fetch qna data when the component is mounted
    console.log('this.qnas:', this.qnas);
  },
};
</script>

<style scoped>
.recruit-container {
  width: 100%;
  background-color: var(--background-gray);
  /* min-height: 200vh; */
  /* padding-bottom: 5rem; */
}



.recruitment-page {
  display: flex;
  max-width: 1416px;
  margin: 0 auto;
  padding: 20px;
  min-height: 90vh;
}

.sidebar {
  width: 200px;
  padding-right: 20px;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.category-button {
  background-color: transparent;
  color: var(--green03);
  margin-bottom: 24px;
  border: none;
  cursor: pointer;

  padding: 6px 12px 6px 12px;
  border-radius: 8px;



  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


}

.category-button.active {
  background-color: var(--green03);
  color: white;

  font-weight: 700;
}

.main-content {
  flex: 1;
}

.qna-card {
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  background-color: white;
  padding: 43px 40px;
  margin-bottom: 20px;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 1176px;
  /* height: 120px; */



  box-sizing: border-box;
}

.question {
  display: flex;
  align-items: center;

  justify-content: space-between;

  width: 100%;
}

.qna-answer {
  padding: 0;
  font-size: 1rem;
  margin-top: 24px;

  /* //styleName: lg/regular; */

  font-family: Inter;
  font-size: 18px;
  font-weight: 400;
  line-height: 26.1px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  white-space: pre-line;

  padding-right: 60px;

  color: var(--gray13);
}


.qna-card h3 {
  margin: 0;
  flex: 1;
  text-align: left;
  /* Ensures text is left-aligned */

  /* //styleName: 2xl/bold; */
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);

}

.toggle-icon {
  font-size: 40px;
  /* 增大 + 和 − 符号 */
  margin-left: auto;
  /* 让加号或减号靠右 */
  margin: 0px;
  margin-right: 8px;

  width: 40px;
  height: 40px;

  border: none;
  background-color: transparent;

}

/* Responsive design for smaller screens */
@media (max-width: 560px) {
  .recruitment-page {
    flex-direction: column;
    width: 343px;
    margin: 0 auto;
    padding: 0;
  }

  .sidebar {
    width: 100%;
    display: flex;
    justify-content: space-around;
    padding: 10px 0;
  }

  .sidebar-menu {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .category-button {
    font-size: 1rem;
    padding: 6px 12px;
    margin: 4px;
    width: auto;

    /* //styleName: md/regular; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .main-content {
    padding: 0;
  }

  .qna-card {
    /* flex-direction: row; */
    width: 343px;
    /* height: 112px; */
    padding: 16px;

    margin-bottom: 20px;

  }

  .qna-answer {

    /* //styleName: sm/regular; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21.56px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 16px;

    padding-right: 40px;


  }

  .qna-card h3 {
    margin-right: 10px;
    flex: 1;
    text-align: left;

    /* //styleName: lg/bold; */
    font-family: Inter;
    font-size: 18px;
    font-weight: 700;
    line-height: 26.1px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


  }


  .toggle-icon {
    position: relative;
    top: 2px;
    left: 5px;
    font-size: 28px;
    /* 增大 + 和 − 符号 */
    /* margin-left: auto; */
    margin-right: 0px;
    /* 让加号或减号靠右 */
  }

}
</style>
